<template>
    <div>
    <div class="login-page">
    <!-- <offline @detected-condition="handleConnectivityChange"></offline> -->
    <!--Sending state-->
    <loading :active.sync="isSending"
    :can-cancel="false"
    :is-full-page="true">
    </loading>
    <!--./Sending state-->
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form>
                <card type="login">
                  <h3 slot="header" class="card-title-orange text-center">Inicio de sesión</h3>
                  <fg-input v-model="form.username"
                            addon-left-icon="nc-icon nc-single-02"
                            placeholder="Nombre de usuario"
                            name="usuario"
                            autocomplete="off"
                            v-validate="modelValidations.username"
                            :error="getError('usuario')"></fg-input>
                  <fg-input v-model="form.password"
                            addon-left-icon="nc-icon nc-key-25"
                            placeholder="Contraseña"
                            name="contraseña"
                            autocomplete="off"
                            v-validate="modelValidations.password"
                            :error="getError('contraseña')"
                            type="password"></fg-input>
                  <!-- <router-link to="/password_change">¿Olvidó su contraseña?</router-link> -->
                  <br>
                  <div class="captcha-wrapper">
                        <vue-hcaptcha
                            :sitekey="hcaptchaSiteKey"
                            theme="dark"
                            ref="captcha"
                            @verify="onVerify"
                            @expired="onExpired"
                            @error="onCaptchaError"></vue-hcaptcha>
                    </div>
                  <div v-if="$store.state.connectivityState" key="connectivity-state">
                      <p-button :disabled="!captchaToken" native-type="submit" @click.prevent="validate" slot="footer" type="warning" round block class="mb-3">Iniciar sesión</p-button>
                  </div>
                  <div v-else key="connectivity-state" class="alert alert-danger">
                      <span>No hay conexión a internet, no es posible iniciar sesión</span>
                  </div>
                  <span style="color: white;">v{{ $store.getters.appVersion }}</span>
                </card>
              </form>
            </div>
          </div>
        </div>
        <div class="full-page-background" v-bind:style="loginBackground()"></div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import Vue from 'vue';
  import swal from 'sweetalert2'
  import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import { activityTypes } from 'src/api/graphql/queries/setup/AllActivityTypes';
  import { productTypes } from 'src/api/graphql/queries/setup/AllProductTypes';
  import { creditTypes } from 'src/api/graphql/queries/setup/AllCreditTypes';
  import { accountTypes } from 'src/api/graphql/queries/setup/AllAccountTypes';
  import { clientTypes } from 'src/api/graphql/queries/setup/AllClientTypes';
  import { financialObligationTypes } from 'src/api/graphql/queries/setup/AllFinancialObligationTypes';
  import { contingentQuotasTdcPyme } from 'src/api/graphql/queries/setup/AllContingentQuotaPyme';
  import { contingentQuotasTdcAgro } from 'src/api/graphql/queries/setup/AllContingentQuotaAgro';
  import { creditPurposes } from 'src/api/graphql/queries/setup/AllCreditPurposes';
  import { identificationDocumentTypes } from 'src/api/graphql/queries/setup/AllIdentificationDocumentTypes';
  import { methodologicalPillars } from 'src/api/graphql/queries/setup/AllMethodologicalPillars';
  import { catalogSalePercent } from 'src/api/graphql/queries/setup/AllCatalogSalePercent';
  import { economicActivities } from 'src/api/graphql/queries/setup/AllEconomicActivities';
  import { professions } from 'src/api/graphql/queries/setup/AllProfessions';
  import { amountTermsFa } from 'src/api/graphql/queries/setup/AllAmountTermsFA';
  import { amountTermsWc } from 'src/api/graphql/queries/setup/AllAmountTermsWC';
  import { commissions } from 'src/api/graphql/queries/setup/AllCommissions';
  import { creditRates } from 'src/api/graphql/queries/setup/AllCreditRates';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import SecureLS from 'secure-ls'
  import { TOKEN_AUTH } from 'src/api/graphql/mutations/auth/TokenAuth';
  import offline from 'v-offline';
  Vue.use(offline);
  export default {
    components: {
      Card,
      Loading,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button,
      offline,
      VueHcaptcha
    },
    /***
    * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
    *
    **/
    apollo:{
        commissions: {
                query: commissions,
                // Disable the query
                skip() {
                    return this.skipCommissionsQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.commissions.edges.length != 0)
                    {
                        this.setCommissions(data.commissions);
                        this.skipCommissionsQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        creditRates: {
                query: creditRates,
                // Disable the query
                skip() {
                    return this.skipCreditRatesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.creditRates.edges.length != 0)
                    {
                        this.setCreditRates(data.creditRates);
                        this.skipCreditRatesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        amountTermsFa: {
                query: amountTermsFa,
                // Disable the query
                skip() {
                    return this.skipAmountTermsFaQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.amountTermsFa.edges.length != 0)
                    {
                        this.setAmountTermsFa(data.amountTermsFa);
                        this.skipAmountTermsFaQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        amountTermsWc: {
                query: amountTermsWc,
                // Disable the query
                skip() {
                    return this.skipAmountTermsWcQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.amountTermsWc.edges.length != 0)
                    {
                        this.setAmountTermsWc(data.amountTermsWc);
                        this.skipAmountTermsWcQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        professions: {
                query: professions,
                // Disable the query
                skip() {
                    return this.skipProfessionsQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.professions.edges.length != 0)
                    {
                        this.setProfessions(data.professions);
                        this.skipProfessionsQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        economicActivities: {
                query: economicActivities,
                // Disable the query
                skip() {
                    return this.skipEconomicActivitiesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.economicActivities.edges.length != 0)
                    {
                        this.setEconomicActivities(data.economicActivities);
                        this.skipEconomicActivitiesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        methodologicalPillars: {
                query: methodologicalPillars,
                // Disable the query
                skip() {
                    return this.skipMethodologicalPillarsQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.methodologicalPillars.edges.length != 0)
                    {
                        this.setMethodologicalPillars(data.methodologicalPillars);
                        this.skipMethodologicalPillarsQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        activityTypes: {
                query: activityTypes,
                // Disable the query
                skip() {
                    return this.skipActivityTypesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.activityTypes.edges.length != 0)
                    {
                        this.setActivityTypes(data.activityTypes);
                        this.skipActivityTypesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        accountTypes: {
                query: accountTypes,
                // Disable the query
                skip() {
                    return this.skipAccountTypesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.accountTypes.edges.length != 0)
                    {
                        this.setAccountTypes(data.accountTypes);
                        this.skipAccountTypesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        clientTypes: {
                query: clientTypes,
                // Disable the query
                skip() {
                    return this.skipClientTypesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.clientTypes.edges.length != 0)
                    {
                        this.setClientTypes(data.clientTypes);
                        this.skipClientTypesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        financialObligationTypes: {
                query: financialObligationTypes,
                // Disable the query
                skip() {
                    return this.skipFinancialObligationTypesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.financialObligationTypes.edges.length != 0)
                    {
                        this.setFinancialObligationTypes(data.financialObligationTypes);
                        this.skipFinancialObligationTypesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        contingentQuotasTdcPyme: {
                query: contingentQuotasTdcPyme,
                // Disable the query
                skip() {
                    return this.skipContingentQuotasTdcQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.contingentQuotasTdcPyme.edges.length != 0)
                    {
                        this.setContingentQuotasTdcPyme(data.contingentQuotasTdcPyme);
                        this.skipContingentQuotasTdcQuery;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        contingentQuotasTdcAgro: {
                query: contingentQuotasTdcAgro,
                // Disable the query
                skip() {
                    return this.skipContingentQuotasTdcAgroQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.contingentQuotasTdcAgro.edges.length != 0)
                    {
                        this.setContingentQuotasTdcAgro(data.contingentQuotasTdcAgro);
                        this.skipContingentQuotasTdcAgroQuery;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        identificationDocumentTypes: {
                query: identificationDocumentTypes,
                // Disable the query
                skip() {
                    return this.skipIdentificationDocumentType
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.identificationDocumentTypes.edges.length != 0)
                    {
                        this.setIdentificationDocumentType(data.identificationDocumentTypes);
                        this.skipIdentificationDocumentTypesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        productTypes: {
                query: productTypes,
                // Disable the query
                skip() {
                    return this.skipProductTypesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.productTypes.edges.length != 0)
                    {
                        this.setProductTypes(data.productTypes);
                        this.skipProductTypesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        creditTypes: {
                query: creditTypes,
                // Disable the query
                skip() {
                    return this.skipCreditTypesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.creditTypes.edges.length != 0)
                    {
                        this.setCreditTypes(data.creditTypes);
                        this.skipCreditTypesQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
        creditPurposes: {
                query: creditPurposes,
                // Disable the query
                skip() {
                    return this.skipCreditPurposesQuery
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.creditPurposes.edges.length != 0)
                    {
                        this.setCreditPurposes(data.creditPurposes);
                        this.skipCreditPurposesQuery = true;
                    }


                },
                // Si encontró algún error.
                error(error) {

                },
        },
        catalogSalePercent: {
                query: catalogSalePercent,
                // Disable the query
                skip() {
                    return this.skipCatalogSalePercent
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.catalogSalePercent.edges.length != 0)
                    {
                        this.setCatalogSalePercent(data.catalogSalePercent);
                        this.skipCatalogSalePercentQuery = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
        },
    },
    methods: {
        resetCaptcha(){
            this.$refs.captcha.reset();
            this.captchaToken = null;
        },
        onVerify (token){
            console.log('✅ Captcha resuelto:', token);
            this.captchaToken = token;
        },
        onExpired (){
            console.warn('⚠️ Captcha expirado');
            this.captchaToken = null;
            swal({
                title: `¡Alerta!`,
                text: "El captcha expiró. Intenta resolverlo nuevamente.",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill',
                type: 'error'
            });
            this.$refs.captcha.resetCaptcha(); // reinicia el widget invisible
        },
        onCaptchaError (err){
            console.error('❌ Error en captcha:', err);
            this.captchaToken = null;
            swal({
                title: `¡Alerta!`,
                text: "Ocurrió un error con el captcha. Por favor, recarga la página o intenta más tarde.",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill',
                type: 'error'
            });
        },
      /**
       * This function adds one to its input.
       * @param {number} input any number
       * @returns {number} that number, plus one.
       */
      showNotificationError (message) {
          this.$notify(
          {
              message: message,
              icon: 'nc-icon nc-glasses-2',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
          })
      },
      /***
      * Función para setear en la tabla los datos que llegan desde el servidor
      */
      setActivityTypes(activityTypes){
          var vm = this;
          this.$store.commit('resetActivityTypes');
          for(let i=0;i<activityTypes.edges.length;i++)
          {
              this.$store.commit('updateActivityTypes',activityTypes.edges[i].node);
          }
          this.count++;
      },
      setAccountTypes(accountTypes){
          var vm = this;
          this.$store.commit('resetAccountTypes');
          for(let i=0;i<accountTypes.edges.length;i++)
          {
              if(accountTypes.edges[i].node.isActive){
                this.$store.commit('updateAccountTypes',accountTypes.edges[i].node);
              }
          }
          this.count++;
      },
      setClientTypes(clientTypes){
          var vm = this;
          this.$store.commit('resetClientTypes');
          for(let i=0;i<clientTypes.edges.length;i++)
          {
              if(clientTypes.edges[i].node.isActive){
                this.$store.commit('updateClientTypes',clientTypes.edges[i].node);
              }
          }
          this.count++;
      },
      setFinancialObligationTypes(financialObligationTypes){
          var vm = this;
          this.$store.commit('resetFinancialObligationTypes');
          for(let i=0;i<financialObligationTypes.edges.length;i++)
          {
              if(financialObligationTypes.edges[i].node.isActive){
                this.$store.commit('updateFinancialObligationTypes',financialObligationTypes.edges[i].node);
              }
          }
          this.count++;
      },
      setContingentQuotasTdcPyme(contingentQuotasTdcPyme){
          var vm = this;
          this.$store.commit('resetContingentQuotasTdcPyme');
          for(let i=0;i<contingentQuotasTdcPyme.edges.length;i++)
          {
              if(contingentQuotasTdcPyme.edges[i].node.data.active){
                this.$store.commit('updateContingentQuotasTdcPyme',contingentQuotasTdcPyme.edges[i].node);
              }
          }
          this.count++;
      },
      setContingentQuotasTdcAgro(contingentQuotasTdcAgro){
          var vm = this;
          this.$store.commit('resetContingentQuotasTdcAgro');
          for(let i=0;i<contingentQuotasTdcAgro.edges.length;i++)
          {
              if(contingentQuotasTdcAgro.edges[i].node.data.active){
                this.$store.commit('updateContingentQuotasTdcAgro',contingentQuotasTdcAgro.edges[i].node);
              }
          }
          this.count++;
      },
      setMethodologicalPillars(methodologicalPillars){
          var vm = this;
          this.$store.commit('resetMethodologicalPillars');
          for(let i=0;i<methodologicalPillars.edges.length;i++)
          {
              this.$store.commit('updateMethodologicalPillars',methodologicalPillars.edges[i].node);
          }
          this.count++;
      },
      setEconomicActivities(economicActivities){
          var vm = this;
          this.$store.commit('resetEconomicActivities');
          for(let i=0;i<economicActivities.edges.length;i++)
          {
              this.$store.commit('updateEconomicActivities',economicActivities.edges[i].node);
          }
          this.count++;
          // for(let i=0;i<10;i++)
          // {
          //     this.$store.commit('updateEconomicActivities',economicActivities.edges[i].node);
          // }

      },
      setProfessions(professions){
          var vm = this;
          this.$store.commit('resetProfessions');
          for(let i=0;i<professions.edges.length;i++)
          {
              this.$store.commit('updateProfessions',professions.edges[i].node);
          }
          this.count++;
      },
      setAmountTermsFa(amountTermsFa){
          var vm = this;
          this.$store.commit('resetAmountTermsFa');
          for(let i=0;i<amountTermsFa.edges.length;i++)
          {
              this.$store.commit('updateAmountTermsFa',amountTermsFa.edges[i].node);
          }
          this.count++;
      },
      setAmountTermsWc(amountTermsWc){
          var vm = this;
          this.$store.commit('resetAmountTermsWc');
          for(let i=0;i<amountTermsWc.edges.length;i++)
          {
              this.$store.commit('updateAmountTermsWc',amountTermsWc.edges[i].node);
          }
          this.count++;
      },
      setIdentificationDocumentType(identificationDocumentTypes){
          var vm = this;
          this.$store.commit('resetIdentificationDocumentTypes');
          for(let i=0;i<identificationDocumentTypes.edges.length;i++)
          {
              this.$store.commit('updateIdentificationDocumentTypes',identificationDocumentTypes.edges[i].node);
          }
          this.count++;
      },
      setCatalogSalePercent(catalogSalePercent){
          var vm = this;
          this.$store.commit('resetCatalogSalePercent');
          for(let i=0;i<catalogSalePercent.edges.length;i++)
          {
              this.$store.commit('updateCatalogSalePercent',catalogSalePercent.edges[i].node);
          }
          this.count++;
      },
      setProductTypes(productTypes){
          var vm = this;
          this.$store.commit('resetProductTypes');
          for(let i=0;i<productTypes.edges.length;i++)
          {
              this.$store.commit('updateProductTypes',productTypes.edges[i].node);
          }
          this.count++;
      },
      setCreditTypes(creditTypes){
          var vm = this;
          this.$store.commit('resetCreditTypes');
          for(let i=0;i<creditTypes.edges.length;i++)
          {
              this.$store.commit('updateCreditTypes',creditTypes.edges[i].node);
          }
          this.count++;
      },
      setCreditPurposes(creditPurposes){
          var vm = this;
          this.$store.commit('resetCreditPurposes');
          for(let i=0;i<creditPurposes.edges.length;i++)
          {
              this.$store.commit('updateCreditPurposes',creditPurposes.edges[i].node);
          }
          this.count++;
      },
      setCommissions(commissions){
          var vm = this;
          this.$store.commit('resetCommissions');
          for(let i=0;i<commissions.edges.length;i++)
          {
              this.$store.commit('updateCommissions',commissions.edges[i].node);
          }
          this.count++;
      },
      setCreditRates(creditRates){
          var vm = this;
          this.$store.commit('resetCreditRates');
          for(let i=0;i<creditRates.edges.length;i++)
          {
              this.$store.commit('updateCreditRates',creditRates.edges[i].node);
          }
          this.count++;
      },
      // Función que verifica si hay internet y muestra el mensaje permanente
      handleConnectivityChange(status) {
        if(status == false)
        {
            this.$store.dispatch('setConnectivityState', status);
            this.$notify(
              {
                  message: 'No hay conexión a internet en este momento',
                  icon: 'nc-icon nc-alert-circle-i',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
              })
        }
        else
        {
            this.$store.dispatch('setConnectivityState', status);
            const url = process.env.VUE_APP_BACKEND_URL +'/api/gencookie';
            fetch(url)
            .then(data => data)
            .then(res => {
              // el resultado no importa, solo importa la cookie

            })
            .catch(error => {
              console.info("Ocurrió un error al obtener la cookie!");
            });
            this.$notify(
              {
                  message: 'La conexión a internet ha sido restablecida',
                  icon: 'nc-icon nc-spaceship',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'success'
              })
        }
      },
      loginBackground(){
        return 'background-image: url('+process.env.VUE_APP_BASE_ROUTE+'img/login_background.jpg)';
      },
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      /***
      * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
      */
      onSuccess(message){
          swal({
              title: `¡Correcto!`,
              text: message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
          });
      },
      /***
      * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
      */
      onError(message){
          swal({
              title: `¡Alerta!`,
              text: message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger btn-fill',
              type: 'error'
          });
      },
      /***
      * Función que permite visualizar los errores en cada campo del input
      */
      getError (fieldName) {
          return this.errors.first(fieldName)
      },
      /***
      * Función para validar el formulario de edición y creación que se envía
      */
      validate () {
          this.$validator.validateAll().then(isValid => {
            if(isValid){
              // Iniciamos el envío de la mutación
              var vm = this;
              vm.isSending = true;
              vm.$apollo.mutate({
                mutation: TOKEN_AUTH,
                variables : {
                    input : {
                      username: vm.form.username,
                      password: vm.form.password,
                      token: vm.captchaToken
                    }
                  }
              }).then((data) => {
                vm.$store.dispatch('updateLoggingIn',data.data.tokenAuth).then(()=>{
                  let promise = new Promise(function(resolve, reject) {
                    if (vm.$store.getters.getActivityTypes.length == 0 || vm.$store.getters.getActivityTypes.length != 0) {
                        vm.$apollo.queries.activityTypes.skip = false;
                        vm.$apollo.queries.activityTypes.refetch();
                    }
                    if (vm.$store.getters.getAccountTypes.length == 0 || vm.$store.getters.getAccountTypes.length != 0) {
                        vm.$apollo.queries.accountTypes.skip = false;
                        vm.$apollo.queries.accountTypes.refetch();
                    }
                    if (vm.$store.getters.getClientTypes.length == 0 || vm.$store.getters.getClientTypes.length != 0) {
                        vm.$apollo.queries.clientTypes.skip = false;
                        vm.$apollo.queries.clientTypes.refetch();
                    }
                    if (vm.$store.getters.getFinancialObligationTypes.length == 0 || vm.$store.getters.getFinancialObligationTypes.length != 0) {
                        vm.$apollo.queries.financialObligationTypes.skip = false;
                        vm.$apollo.queries.financialObligationTypes.refetch();
                    }
                    if (vm.$store.getters.getContingentQuotasTdcPyme.length == 0 || vm.$store.getters.getContingentQuotasTdcPyme.length != 0) {
                        vm.$apollo.queries.contingentQuotasTdcPyme.skip = false;
                        vm.$apollo.queries.contingentQuotasTdcPyme.refetch();
                    }
                    // if (vm.$store.getters.getContingentQuotasTdcAgro.length == 0 || vm.$store.getters.getContingentQuotasTdcAgro.length != 0) {
                    //     vm.$apollo.queries.contingentQuotasTdcAgro.skip = false;
                    //     vm.$apollo.queries.contingentQuotasTdcAgro.refetch();
                    // }
                    if (vm.$store.getters.getProductTypes.length == 0 || vm.$store.getters.getProductTypes.length != 0) {
                        vm.$apollo.queries.productTypes.skip = false;
                        vm.$apollo.queries.productTypes.refetch();
                    }
                    if (vm.$store.getters.getCreditTypes.length == 0 || vm.$store.getters.getCreditTypes.length != 0) {
                        vm.$apollo.queries.creditTypes.skip = false;
                        vm.$apollo.queries.creditTypes.refetch();
                    }
                    if (vm.$store.getters.getCreditPurposes.length == 0 != vm.$store.getters.getCreditPurposes.length != 0) {
                        vm.$apollo.queries.creditPurposes.skip = false;
                        vm.$apollo.queries.creditPurposes.refetch();
                    }
                    if (vm.$store.getters.getIdentificationDocumentTypes.length == 0 || vm.$store.getters.getIdentificationDocumentTypes.length != 0) {
                        vm.$apollo.queries.identificationDocumentTypes.skip = false;
                        vm.$apollo.queries.identificationDocumentTypes.refetch();
                    }
                    if (vm.$store.getters.getCatalogSalePercent.length == 0 ||vm.$store.getters.getCatalogSalePercent.length != 0) {
                        vm.$apollo.queries.catalogSalePercent.skip = false;
                        vm.$apollo.queries.catalogSalePercent.refetch();
                    }
                    if (vm.$store.getters.getMethodologicalPillars.length == 0 ||vm.$store.getters.getMethodologicalPillars.length != 0) {
                        vm.$apollo.queries.methodologicalPillars.skip = false;
                        vm.$apollo.queries.methodologicalPillars.refetch();
                    }
                    if (vm.$store.getters.getEconomicActivities.length == 0 ||vm.$store.getters.getEconomicActivities.length != 0) {
                        vm.$apollo.queries.economicActivities.skip = false;
                        vm.$apollo.queries.economicActivities.refetch();
                    }
                    if (vm.$store.getters.getProfessions.length == 0 ||vm.$store.getters.getProfessions.length != 0) {
                        vm.$apollo.queries.professions.skip = false;
                        vm.$apollo.queries.professions.refetch();
                    }
                    // if (vm.$store.getters.getAmountTermsFa.length == 0 ||vm.$store.getters.getAmountTermsFa.length != 0) {
                    //     vm.$apollo.queries.amountTermsFa.skip = false;
                    //     vm.$apollo.queries.amountTermsFa.refetch();
                    // }
                    // if (vm.$store.getters.getAmountTermsWc.length == 0 ||vm.$store.getters.getAmountTermsWc.length != 0) {
                    //     vm.$apollo.queries.amountTermsWc.skip = false;
                    //     vm.$apollo.queries.amountTermsWc.refetch();
                    // }
                    // if (vm.$store.getters.getCommissions.length == 0 ||vm.$store.getters.getCommissions.length != 0) {
                    //     vm.$apollo.queries.commissions.skip = false;
                    //     vm.$apollo.queries.commissions.refetch();
                    // }
                    // if (vm.$store.getters.getCreditRates.length == 0 ||vm.$store.getters.getCreditRates.length != 0) {
                    //     vm.$apollo.queries.creditRates.skip = false;
                    //     vm.$apollo.queries.creditRates.refetch();
                    // }
                    vm.resolvePromise = resolve;
                  }).then(function(resolve){
                      vm.isSending = false;
                      vm.$router.push('/');
                  });
                });

              }).catch((error) => {
                vm.resetCaptcha();
                vm.isSending = false;
                if(error.graphQLErrors.length > 0)
                {
                  if (error.graphQLErrors[0].message == "There is already a session started with these credentials.") {
                    vm.onError("Ya hay una sesión iniciada para este usuario, cierra esa sesión o contacta al administrador");
                  }
                  else if(error.graphQLErrors[0].message == "Please, enter valid credentials") {
                    vm.onError("Las credenciales son incorrectas");
                  }
                  else {
                    vm.onError(error.graphQLErrors[0].message);
                  }

                }
                else if (error.networkError) {
                  switch (error.networkError.statusCode) {
                    case 500:
                      vm.onError("Ha ocurrido un error en el servidor, contacte con el administrador del sistema");
                      break
                    case 403:
                      if (error.networkError.bodyText == 'Cuenta bloqueada: demasiados intentos de inicio de sesión. Por favor, inténtelo de nuevo más tarde') {
                        vm.onError(error.networkError.bodyText);
                      }
                      else {
                        vm.onError("La verificación de CSRF ha fallado. Recarga la página e intenta de nuevo");
                      }
                      break
                    case undefined:
                      vm.onError("Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo");
                      break
                    default:
                      vm.onError("Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo");
                      break
                  }
                }
                else
                {
                  vm.onError('Las credenciales son incorrectas');
                }
              });
            }
          })
      }
    },
    data() {
      return {
        hcaptchaSiteKey: process.env.VUE_APP_HCAPTCHA_KEY,
        captchaToken: null,
        count: 0,
        resolvePromise: null,
        skipEconomicActivitiesQuery: true,
        skipProfessionsQuery: true,
        skipAmountTermsFaQuery: true,
        skipAmountTermsWcQuery: true,
        skipCommissionsQuery: true,
        skipCreditRatesQuery: true,
        skipMethodologicalPillarsQuery: true,
        skipAccountTypesQuery: true,
        skipClientTypesQuery: true,
        skipFinancialObligationTypesQuery: true,
        skipContingentQuotasTdcQuery: true,
        skipContingentQuotasTdcAgroQuery: true,
        skipActivityTypesQuery: true,
        skipProductTypesQuery: true,
        skipCreditTypesQuery: true,
        skipCreditPurposesQuery: true,
        skipIdentificationDocumentTypesQuery: true,
        skipCatalogSalePercentQuery: true,
        isSending: false,
        fullPage: false,
        form: {
          username: '',
          password: ''
        },
        modelValidations: {
          username: {
              alpha_dash: true,
              required: true,
              max: 32
          },
          password: {
              required: true,
              max: 32
          },
        },
      }
    },
    watch: {
      count: function(newVal, oldVal) {
        if (newVal == 13) {
          this.resolvePromise(true);
        }
      }
    },
    mounted(){
      this.count = 0;
      const url = process.env.VUE_APP_BACKEND_URL +'/api/gencookie';
      fetch(url)
      .then(data => data)
      .then(res => {
        // el resultado no importa, solo importa la cookie

      })
      .catch(error => {
        console.info("Ocurrió un error al obtener la cookie!");
      });
    },
    beforeDestroy() {
      this.closeMenu();
    }
  }
</script>
<style>
.captcha-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
